import {Component, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Data, NavigationEnd, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {L10nTranslationService} from 'angular-l10n';
import {combineLatest} from 'rxjs';
import {filter, map, mergeMap} from 'rxjs/operators';

import {AppSettingsService} from './shared';
import * as fromRoot from './shared/reducers';
import {SignalrService} from './signalr.service';

@Component({ selector: 'storever-root', template: '<router-outlet></router-outlet>' })
export class AppComponent implements OnInit, OnDestroy {
  constructor(private viewContainerRef: ViewContainerRef,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private title: Title,
              private signalrService: SignalrService,
              private translation: L10nTranslationService,
              private appSettings: AppSettingsService,
              private store: Store<fromRoot.AppState>) {
    // this.translation.translationChanged.subscribe(lang => this.store.dispatch(new SetLanguageAction(lang)));
    // this.toast.setRootViewContainerRef(this.viewContainerRef);
    // this.locale.addConfiguration().addLanguages(['en', 'fr', 'cn', 'es']).useLocalStorage().defineLanguage('en');
    // this.locale.init();
    //
    // this.translation.addConfiguration().addProvider('./assets/locales/locale-');
    // this.translation.init();
    this.appSettings.init();
  }

  ngOnInit() {
    console.log('AppComponent')
    const pageTitle$ = this.router.events.pipe(filter(event => event instanceof NavigationEnd),
                                               map(() => this.activatedRoute),
                                               map(route => {
                                                 while (route.firstChild) {
                                                   route = route.firstChild;
                                                 }

                                                 return route;
                                               }),
                                               filter(route => route.outlet === 'primary'),
                                               mergeMap(route => route.data),
                                               map((data: Data) => data['title'] || 'DEFAULT_TITLE'));

    combineLatest(this.store.select(fromRoot.selectors.getLanguage), pageTitle$, (lang, title) => this.translation.translate(title))
      .subscribe(translatedTitle => this.title.setTitle(translatedTitle));
    // this.router.navigate(['/dashboard']);
    // Start the connection to SignalR when the component initializes
    // console.log('Invoke signalr service connection from app.component');
    // // this.signalrService.startConnection();
    //
    // // Listen to an event from SignalR (replace with your own event name)
    // console.log('Add listerner to Received message');
    // this.signalrService.addListener('ReceiveMessage', (message) => {
    //   console.log('Received message:', message);
    // });
  }
  ngOnDestroy(): void {
    // Stop connection when the component is destroyed
    // console.log('Stop connection from app.component');
    // this.signalrService.stopConnection();
  }
}
